import { useSyncExternalStore } from 'react';
import type { PlaneView } from '~/engine/view/views/PlaneView';
import { RenderAdapter } from '../types';
import { planeViewOf } from './ports/PlaneViewRenderAdapter';

/**
 * The engine view behind a tile's renderer, followed across mounts: the
 * renderer announces a mount on its cursor source, and the view read then
 * is the snapshot, so the caller re-renders when the view is replaced and
 * not on every cursor move.
 */
export function usePlaneViewOf(renderer: RenderAdapter): PlaneView | undefined {
    const source = renderer.getCursorSource();
    return useSyncExternalStore(source.subscribe, () => planeViewOf(renderer));
}
